export const RETREAT_START = 'RETREAT_BUTTON/RETREAT_START';
export const RETREAT = 'RETREAT_BUTTON/RETREAT';
export const RETREAT_DONE = 'RETREAT_BUTTON/RETREAT_DONE';

export const CHOOSE_BENCH_POSITION = 'RETREAT_BUTTON/CHOOSE_BENCH_POSITION';
